namespace Nobox {
    export enum FormStatusEnum {
        Pending = 0,
        Process = 1,
        Complete = 2,
        Refund = 3,
        Cancel = 4
    }
    Serenity.Decorators.registerEnumType(FormStatusEnum, 'Nobox.FormStatusEnum');
}
